import React, { useRef } from 'react'
/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { Space,Table ,DatePicker,Pagination, Select, Input} from 'antd';
import {DollarOutlined } from '@ant-design/icons';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import MoneyOutlinedIcon from '@mui/icons-material/MoneyOutlined';
import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined';
import {PlusCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import axios from './apiClient';
import Alert from './alert';
import moment from 'moment/moment';
import jwtDecode from 'jwt-decode';
import { Tabs } from '@mui/material';
import { useLang } from '../context';

const {RangePicker} = DatePicker;

export default function Dashboard() {

  const [page,setPage] = useState(1);
  const [statements,setStatements] = useState([]);
  const [totalStatements, setTotalStatements] = useState();
  const [loading,setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [trnxType, setTrnxType] = useState("all");
  const [date,setDate] = useState({startDate: "",endDate: ""})
  const [balance,setBalance] = useState('');
  const [totalMembers,setTotalMembers] = useState('');
  const [totalSubAgents,setTotalSubAgents] = useState('');
  const [totalDepositAmount,setTotalDepositAmount] = useState(0);
  const [totalWithdrawAmount,setTotalWithdrawAmount] = useState(0);
  const [commission,setCommission] = useState(0);
  const {text} = useLang();

  const didMount = useRef(false);

  const trnxTypeOptions = ['all', 'deposit', 'withdraw']

  const navigate = useNavigate()


   useEffect(()=>{
    const today = moment();
    const startDate = moment(today).subtract(30, 'days').format('YYYY-MM-DD');
    const endDate = moment(today).format('YYYY-MM-DD');
    setDate({startDate: startDate,endDate: endDate})
   },[])

  async function fetchData() {
    setLoading(true)
     let data = await axios.get(`/report/getStatementByHolderId?type=${trnxType}&startDate=${date.startDate}&endDate=${date.endDate}&current=${page}&pageSize=10`);
     
    if (data.code != 200) {
        if(data.code == 404){
            setLoading(false)
            setStatements([])
            return
        }
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setStatements(data.data.transactions)
    setTotalStatements(data.data.pagination.total)
    setLoading(false)
  }

  async function getBalance(){
    let res = await axios.get(`/report/agentDashboard`);
     if(res.code == 200) {
       const {balance,totalMember,totalSubAgent} = res.data;
       setBalance(balance);
       setTotalMembers(totalMember);
       setTotalSubAgents(totalSubAgent);
     }
  }

   async function getCommission(){
    const token = localStorage.getItem("token");
    const {id: agentId} = jwtDecode(token)
    let res = await axios.get(`/agent/getCommissionList?agentId=${agentId}&startDate=${date.startDate}&endDate=${date.endDate}&current=${page}&pageSize=10`)
    if(res.code != 200) return;
    setCommission(Number(res.data.totalCommissionAmount).toLocaleString())
  }


  async function getTotalDepositAndWithdraw(){
    let res = await axios.get(`/report/getTotalDepositAndWithdrawByDate?startDate=${date.startDate}&endDate=${date.endDate}`)
    if(res.code != 200) return;
    let {total_deposit_amount,total_withdraw_amount} = res.data;
    setTotalDepositAmount(total_deposit_amount);
    setTotalWithdrawAmount(total_withdraw_amount);
  }


  const handleCloseAlert = () => setOpenAlert(false)
  
  const handlePageChange = (page) => setPage(page)

  const handleTrnxTypeChange = (value) => setTrnxType(value);
  
  const handleDateChange = async (v,dateString) => setDate({startDate: dateString[0],endDate: dateString[1]});
  
  useEffect(()=> {
    getTotalDepositAndWithdraw();
    getCommission();
    if(didMount.current){
      fetchData()
    }else{
      didMount.current = true;
      getBalance();
    }
  },[trnxType,date,page])

  const columns = [
      // {
      //   title: 'Username',
      //   render: ()=> holderName
      // },
      {
        title: text['Trnx Type'],
        dataIndex: 'trnxType',
        key: 'trnxType',
      },
      {
        title: text['Status'],
        key: 'status',
        dataIndex: 'status',
      },
      {
        title: text['Date'],
        key: 'trnxDate',
        dataIndex: 'trnxDate',
        render: (date) => moment(date).format("DD-MM-YYYY h:mm A")
      },
      {
        title: text['Reason'],
        key: 'reason',
        dataIndex: 'reason',
      },
      {
        title: text['Amount'],
        key: 'amount',
        dataIndex: 'amount',
      },
      {
        title: text['Opening Balance'],
        key: 'openingBalance',
        dataIndex: 'openingBalance',
      },
      {
        title: text['Closing Balance'],
        key: 'closingBalance',
        dataIndex: 'closingBalance',
      },
  ];

    return (
      <div>
    <div>
       <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
       <div  style={{display: 'flex', overflowX: "scroll",overflow: 'hidden'}}>
        <Tabs
            indicatorColor="primary"
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            aria-label="scrollable force tabs example"
          >
          <div style={{display: 'flex',alignItems: "center",padding: "0 3rem 2rem 1rem"}}>
            <DollarOutlined  style={{fontSize: "2.5rem",marginRight: "1rem",color: "green"}}/>
            <div style={{}}>
               <h3 style={{marginBottom: "1rem",fontWeight: "normal"}}>Balance</h3>
               <h3 style={{fontWeight: "normal",color: "black"}}>{Number(balance).toLocaleString()}</h3>
            </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 3rem 2rem 1rem"}}>
            <PersonOutlineOutlinedIcon   style={{fontSize: "2.5rem",marginRight: "1rem",color: "orange"}}/>
             <div>
               <h3 style={{marginBottom: "1rem",fontWeight: "normal"}}>Total Members</h3>
               <h3 style={{fontWeight: "normal",color: "black"}}>{totalMembers}</h3>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 3rem 2rem 1rem"}}>
            <PeopleOutlineOutlinedIcon   style={{fontSize: "2.5rem",marginRight: "1rem",color: "violet"}}/>
             <div>
               <h3 style={{marginBottom: "1rem",fontWeight: "normal"}}>Total Sub Agents</h3>
               <h3 style={{fontWeight: "normal",color: "black"}}>{totalSubAgents}</h3>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 3rem 2rem 1rem"}}>
            <MoneyOutlinedIcon    style={{fontSize: "2.5rem",marginRight: "1rem",color: "#399bac"}}/>
             <div>
               <h3 style={{marginBottom: "1rem",fontWeight: "normal"}}>Total Deposit Amount</h3>
               <h3 style={{fontWeight: "normal",color: "black"}}>{Number(totalDepositAmount).toLocaleString()}</h3>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 3rem 2rem 1rem"}}>
            <CurrencyExchangeOutlinedIcon   style={{fontSize: "2.5rem",marginRight: "1rem",color: "#cc4a3f"}}/>
             <div>
               <h3 style={{marginBottom: "1rem",fontWeight: "normal"}}>Total Withdraw Amount</h3>
               <h3 style={{fontWeight: "normal",color: "black"}}>{Number(totalWithdrawAmount).toLocaleString()}</h3>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 2rem 2rem 1rem"}}>
            <PlusCircleOutlined  style={{fontSize: "2.5rem",marginRight: "1rem",color: "#5c6cc7"}}/>
             <div>
               <h4 style={{marginBottom: "1rem",fontWeight: "normal"}}>Commision</h4>
               <h4 style={{fontWeight: "normal",color: "black"}}>{commission}</h4>
             </div>
          </div>
          <div>
          </div>
        </Tabs>
       </div>
       <div style={{display: 'flex'}}>
         <Space direction="vertical" size={12}>
          <RangePicker
            value={date.startDate ? [dayjs(date.startDate, 'YYYY-MM-DD'), dayjs(date.endDate, 'YYYY-MM-DD')] : ''}
            onChange={(v,dateString)=> handleDateChange(v,dateString)}/>
          </Space>
          <Select
            defaultValue='all'
            style={{width: "20%",marginLeft: "2rem"}}
            onChange={handleTrnxTypeChange}
            // filterOption={(inputValue, option)=> {return option.label.toLowerCase().includes(inputValue.toLowerCase());}}
            showSearch
            options={trnxTypeOptions.map((c)=> ({value: c,label: c}))}
            placeholder="Select Category"
          />
       </div>
      <Table loading={loading} scroll={{ x: 'max-content' }} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={statements} />
      <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={totalStatements} pageSize={10} showSizeChanger={false} onChange={(page) => handlePageChange(page)} />
    </div>
  </div>
  )
}
